<script>
const errorsMap = {
  non_field_errors: {
    'Server response is not a JSON.':
      'An unexpected server error has occured. Please contact your Customer Success Manager.',
  },
  email: {
    'This field must be unique.':
      'An account with this email already exists. If you believe this is an error, please contact your Customer Success Manager.',
  },
  group_ids: {
    'At least one assigned user could not be found.': 'Choosen groups do not contain any users to assign the lesson',
  },
};

export default {
  name: 'ErrorMapperMixin',

  data() {
    return {
      errors: {},
    };
  },

  computed: {
    mappedErrors() {
      if (this.errors && this.errors.detail) {
        if (typeof this.errors.detail === 'string') {
          return { non_field_errors: [this.errors.detail] };
        }
        return this.errors.detail;
      }
      return Object.keys(this.errors)
        .filter(key => Array.isArray(this.errors[key]))
        .reduce((memo, field) => {
          memo[field] = this.errors[field].map(error => {
            const customError = errorsMap[field] ? errorsMap[field][error] : null;
            return customError || error;
          });
          return memo;
        }, {});
    },

    hasMappedErrors() {
      return Object.keys(this.mappedErrors).length !== 0;
    },
  },
};
</script>
